export default __webpack_public_path__ + "static/OmraneKayabas-0da671e38b2182697cbf1bc35afc094c.png";